import { getGenerationErrorDetails } from './generation-error-details.js';

// SDK 5.60.3 Project's runtime/staleness timers fail locally before their
// artistCanceled notification has a server receipt. Worker timeouts do not
// use these exact code-0 messages and must retain their normal failure path.
export function isSdkLocalImageTimeout(error) {
  const details = getGenerationErrorDetails(error);
  if (details.code !== 0 && details.code !== '0') return false;
  return details.message === 'Job timed out'
    || details.message === 'Project timed out. Please try again or contact support.'
    || /^Job exceeded the maximum runtime of \d+ (?:minutes?|hours?)$/.test(details.message)
    || /^Job \S+ exceeded the maximum runtime of \d+ (?:minutes?|hours?); project canceled$/.test(details.message);
}

// These live SDK/application outcomes cannot confirm that the accepted image
// failed: a session was cleared, a result URL is absent, or lookup lost it.
export function isImageDeliveryUnverified(error, projectId = null) {
  const details = getGenerationErrorDetails(error);
  if (isSdkLocalImageTimeout(error)) return true;
  if (details.unverified === true || details.originalCode === 'projectLost') return true;
  if (['PROJECT_RESULT_UNVERIFIED', 'IMAGE_RESULT_MISSING', 'PROJECT_LOST'].includes(String(details.code))) return true;
  return details.code === 'SESSION_IDENTITY_CHANGED' && Boolean(projectId || details.projectId);
}
